<div class="copilot-header" data-element="copilot-tab-bar">
  <!-- CR-20260831-004 round 3: .param-changed = the active tab is not the last-run tab. -->
  <dx-button-group
    [class.param-changed]="this.notLastRunTab"
    [items]="this.tabItems"
    keyExpr="id"
    selectionMode="single"
    stylingMode="contained"
    [disabled]="this.disabled"
    [selectedItemKeys]="[this.activeTab]"
    (onItemClick)="this.onItemClick($event)"
  ></dx-button-group>
</div>
